import { Component } from '@angular/core';

@Component({
  templateUrl: './home2.component.html',
})
export class HomeComponent {

}



// WEBPACK FOOTER //
// ./src/app/marketing/home.component.ts